import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  TemplateRef,
  Type,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';
import { IconType, TRole } from '@aksia/infrastructure';
import { IconComponent } from '../../presentation/icon/icon.component';
import { HasRoleDirective } from '../../../directives/ui/ui-has-role.directive';

export type TTabItem = {
  title: string;
  icon?: {
    iconDefinition: IconType;
    iconSize?: string;
    iconColor?: string;
    iconClass?: string;
  };
  routerLink: string;
  routerLinkActive?: string;
  role?: TRole;
};

@Component({
  selector: 'page-tab',
  imports: [CommonModule, RouterModule, IconComponent, HasRoleDirective],
  templateUrl: './page-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTabComponent extends UiControlDirective {
  //#region Host Bindings

  @HostBinding('attr.uipagetab') uipagetab = '';

  //#endregion

  //#region Inputs

  tabItemsTemplateRef = input<TemplateRef<any> | null>(null);
  tabItemsComponentRef = input<Type<any> | null>(null);
  tabItems = input<Array<TTabItem> | undefined>(undefined);

  //#endregion
}
